export default "__VITE_PUBLIC_ASSET__c7a21458__"